var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessages = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 23.692,
    viewBox: "0 0 26 23.692",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "messages",
    fill: "#707070",
    d: "M4.753 23.373a1.3 1.3 0 0 1-2.153-.957V19.5A2.6 2.6 0 0 1 0 16.9V7.8a2.6 2.6 0 0 1 2.6-2.6h14.3a2.6 2.6 0 0 1 2.6 2.6v9.1a2.6 2.6 0 0 1-2.6 2.6h-6.5zm1.1-4.021a.7.7 0 0 0 .338-.09l3.059-2.129a1.3 1.3 0 0 1 .742-.233H15.6a1.3 1.3 0 0 0 1.3-1.3V9.1a1.3 1.3 0 0 0-1.3-1.3H3.9a1.3 1.3 0 0 0-1.3 1.3v6.5a1.309 1.309 0 0 0 1.3 1.3 1.7 1.7 0 0 1 1.1.294c.166.174.175.468.2 1.027v.481a.65.65 0 0 0 .65.65zM20.8 13.021q-.006.24 0 .481v-.481c.026-.559.036-.853.2-1.027a1.7 1.7 0 0 1 1.1-.294 1.309 1.309 0 0 0 1.3-1.3V3.9a1.3 1.3 0 0 0-1.3-1.3H10.4a1.3 1.3 0 0 0-1.3 1.3H6.5V2.6A2.6 2.6 0 0 1 9.1 0h14.3A2.6 2.6 0 0 1 26 2.6v9.1a2.6 2.6 0 0 1-2.6 2.6v2.916a1.3 1.3 0 0 1-2.153.957l-.447-.307v-4.844z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessages);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/messages.e997a7aaad824136700c985137a68552.svg";